module.exports = __webpack_public_path__ + "img/phonegap.03ffc76d.png";